import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FilterBar } from './components/FilterBar';
import { FeaturedGrid } from './components/FeaturedGrid';
import { HowItWorks } from './components/HowItWorks';
import { TrustSection } from './components/TrustSection';
import { Footer } from './components/Footer';
function setMeta(name: string, content: string, property?: boolean) {
  const attr = property ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    document.title = '新加坡是您网 IsYou - 新加坡领先的高端伴游服务平台 | Singapore Premium Companion Service';
    document.documentElement.lang = 'zh-CN';
    // Basic SEO
    setMeta('description', '新加坡是您网 IsYou - 新加坡领先的高端伴游服务平台，汇集全球优质伴游女郎，提供欧美、日韩、越南、中国等多国伴游服务。真人核验，安全可靠，见面满意后付款。Singapore premium companion escort service.');
    setMeta('keywords', '新加坡伴游,Singapore escort,高端伴游,伴游服务,IsYou,是您网,新加坡是您网,欧美伴游,日韩伴游,越南伴游,中国伴游,premium companion,Singapore companion service,geylang');
    setMeta('author', 'IsYou 是您网');
    setMeta('robots', 'index, follow');
    // Open Graph
    setMeta('og:title', '新加坡是您网 IsYou - 高端伴游服务平台', true);
    setMeta('og:description', '新加坡领先的高端伴游服务平台，汇集全球优质伴游女郎。真人核验，安全可靠，见面满意后付款。', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://www.geylang777-3.site', true);
    setMeta('og:locale', 'zh_CN', true);
    setMeta('og:site_name', 'IsYou 是您网', true);
    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', '新加坡是您网 IsYou - 高端伴游服务平台');
    setMeta('twitter:description', '新加坡领先的高端伴游服务平台，汇集全球优质伴游女郎。真人核验，安全可靠，见面满意后付款。');
  }, []);
  return <div className="min-h-screen bg-dark-900 text-white font-sans selection:bg-gold-500 selection:text-dark-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <FilterBar data-id="element-4" />
        <FeaturedGrid data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <TrustSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}